module.exports = __webpack_public_path__ + "img/gato-mobile.efd89b13.png";